import { atom } from 'recoil';

export const withDebugMenuFeatureFlags = atom<Record<string, boolean>>({
  key: 'debugMenu.featureFlags',
  default: {}
});
